import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled.div`
  padding: 15px 15px 0;
  background-color: ${({ theme }) => theme.palette.primary.background};
  border-top: 1px solid ${({ theme }) => theme.palette.primary.border};
  margin-top: 10px;
`;

export const Text = styled(Typography.Body)`
  margin-top: 20px;
`;
